<script>
import Terms from "../components/Terms.svelte";
import { onMount } from "svelte";
import Historyback from "../components/Historyback.svelte";

onMount(() => {
    window.scroll(0, 0);
});
</script>

<div class="flex jc-between">
    <h2>利用規約</h2>
    <Historyback />
</div>
<Terms />
<div class="flex jc-end">
    <Historyback />
</div>
